/** Metadatos de la guía. Completar `lastUpdated` cuando haya una fecha oficial. */
export const guideMeta: { lastUpdated?: string } = {}

/**
 * Acceso al panel /guia/verificacion. Aunque esté en true, solo se muestra dentro del
 * editor de Magic Patterns (ver utils/staffMode.ts); en el sitio publicado nunca aparece.
 */
export const showVerificationAccess = true

/** Accesos rápidos del inicio de la guía (ids de fichas). El primero se destaca. */
export const quickLinkIds = ['invasiones', 'horarios-invasiones', 'red-dragon', 'jewel-of-chaos']

/** Búsquedas sugeridas bajo el buscador. */
export const searchSuggestions = ['Cómo hago las alas', 'Evo 2', 'Cómo evoluciono mi mago', 'Quest del Marlon', 'Pluma de condor', '¿Dónde aparece Red Dragon?', 'Qué dropea Bull Fighter', 'Cómo entro a Barracks']
